<template>
  <div class="card-container">
    <slot name="image">
      <Skeleton class="image" />
    </slot>
    <slot name="desc">
      <Skeleton class="desc" />
    </slot>
  </div>
</template>

<script>
import Skeleton from "./skeleton";

export default {
  name: "SkeletonCard",

  components: {
    Skeleton
  }
};
</script>

<style lang="scss" scoped>
.card-container {
  .image {
    width: 110px;
    height: 70px;
    border-radius: 6px;
  }
  .desc {
    margin-top: 5px;
    width: 110px;
    height: 30px;
    border-radius: 4px;
  }
}
</style>
